const isDa1 = () => {
  return location.href.match(/https:\/\/da[\d].ulta.com/);
};
const isQa1 = () => {
  return location.href.match(/https:\/\/qa[\d].ulta.com/);
};
const isProd = () => {
  return location.href.indexOf("www.ulta.com") >= 0;
};

let _SDKbaseURI = LOCAL_SERVICE_URL;
let _SDKbaseURIkey = "d78g4q5cfWPs0A6oiePKLJwWC22eLOy7";
if (isDa1()) {
  _SDKbaseURI = "https://services-dev.ultainc.com";
  _SDKbaseURIkey = "d78g4q5cfWPs0A6oiePKLJwWC22eLOy7";
}
if (isQa1()) {
  _SDKbaseURI = "https://services-qa.ultainc.com";
  _SDKbaseURIkey = "d78g4q5cfWPs0A6oiePKLJwWC22eLOy7";
}
if (isProd()) {
  _SDKbaseURI = "https://services.ultainc.com";
  _SDKbaseURIkey = "7iNuS5yY2Iy8G6ZUay7uvsrmPHwrygsV";
}

export const SDKbaseURI = _SDKbaseURI;
export const SDKbaseURIkey = _SDKbaseURIkey;
export const webBaseURI = "https://www.ulta.com/ulta/common";
export const configsAPI = "/agr/api/v1/configs?platform=2&grouped=1";
export const searchAPI = "/agr/api/v1/product-search?grouped=1";
export const useCache = false;
export const searchAPIPageSize = 30;
export const inventoryURI = "/inc/productQuickViewInventoryCheck.jsp";
export const cartURI = "/productQuickViewSummary.jsp";
export const environment = "prod";

export const reStyleCategory = "hair";
export const reStyleURI = "https://services-dev.ultainc.com/v2/api/hair";
export const reStyleURIkey = "PAKGPn12AxYBd2DmEInGCpfviYMUAQ8r";
export const reStyleCategories = "/categories";
export const reStyleUploadSelfie = "/selfies";
export const reStyleSetHairstyles = "/selfies/:selfieId?genomeIds=:genomeIds";
export const reStyleGetSelfies = "/selfies/:selfieId";
export const reStyleGetTransfers = "/selfies/:selfieId/transfers?genomeIds=:genomeIds";
export const reStyleGetConfigs = "/configs";

export const nftActivityURI = isProd()
  ? "https://services.ultainc.com/innovation/api/nft/v1/activity"
  : "https://services-dev.ultainc.com/innovation/api/nft/v1/activity";
export const nftActivityAPIKey = isProd() ? "bBZmfh8lLMo4EAvYkeS8IKmtEvaJ6oKv" : "vTAdVJMYpGfUAZmIT73p4NKAxw6Gyopf";
